import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["width", "height", "fill"];
import React from 'react';

var TwoManDeliveryIcon = function TwoManDeliveryIcon(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#333' : _ref$fill,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: fill,
    width: width,
    height: height
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.896 19.5a2.751 2.751 0 0 1-5.292 0H9.146a2.751 2.751 0 0 1-5.292 0h-1.64a.75.75 0 0 1-.75-.752L1.5 4.498a.75.75 0 0 1 .75-.748h13.5a.75.75 0 0 1 .75.75v3h3.108a.75.75 0 0 1 .61.314l2.142 3c.091.127.14.28.14.436v7.5a.75.75 0 0 1-.75.75h-2.854zm0-1.5H21v-6.51L19.222 9H16.5v3.75a.75.75 0 1 1-1.5 0v-7.5H2.998L2.966 18h.888a2.751 2.751 0 0 1 5.292 0h4.458a2.751 2.751 0 0 1 5.292 0zM6.5 20a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5zm9.75 0a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z"
  }));
};

TwoManDeliveryIcon.displayName = 'TwoManDeliveryIcon';
export default TwoManDeliveryIcon;